/*
 * Model for content topics
 */

define([
  "backbone",
  "jquery",
  "configuration/properties",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicModel",
  "modules/shared/sortableList/sortableListModel",
], function (Backbone, $, Properties, Messenger, TopicModel, SortableListModel) {
  var ContentTopicsModel = {};

  ContentTopicsModel.contentTopics = Backbone.Collection.extend({
    model: TopicModel.topic,
    comparator: function (a, b) {
      //sort using the intent names
      var aName = "";
      var bName = "";
      if (a.intentName) {
        aName = a.intentName;
      }
      if (b.intentName) {
        bName = b.intentName;
      }
      if (aName < bName) {
        return -1;
      } else if (aName > bName) {
        return 1;
      } else {
        return 0;
      }
    },
  });

  //Request for a specific mapped content
  Messenger.reqres.setHandler(
    "content:topics",
    function (mappingId) {
      var kbId = Messenger.reqres.request("active:kb");
      var content = new ContentTopicsModel.contentTopics();
      if (mappingId) {
        content.fetch({ url: Properties.rootURL + "/" + kbId + "/intents/mapping/" + mappingId });
      }
      return content;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "content:topics:headers",
    function () {
      var Header = SortableListModel.headerModel;
      return new Backbone.Collection([
        new Header({
          headerName: $.t("content.topics.title"),
          modelAttribute: "intentName",
          selectable: true,
          sortable: true,
          filterable: false,
        }),
      ]);
    },
    this,
  );

  return ContentTopicsModel;
});
